// extracted by mini-css-extract-plugin
export var typingIndicator = "_q9-0";